import config from 'shared/config/config';
import { hpxConfig } from 'shared/config/hpx_config';
import { iceCstlConfig } from 'shared/config/icecstl_config';
import { clubmedConfig } from 'shared/config/clubmed_config';
import { legacyConfig } from 'shared/config/legacy_config';

export const HPX_THEME = 'hpx';
export const ICECASTLE_THEME = 'icecstl';
export const CLUBMED_THEME = 'clubmed';
export const LEGACY_THEME = 'legacy';

export const setThemeConfig = theme => {
  switch (theme) {
    case HPX_THEME:
      hpxConfig(config);
      break;

    case ICECASTLE_THEME:
      iceCstlConfig(config);
      break;

    case CLUBMED_THEME:
      clubmedConfig(config);
      break;

    case LEGACY_THEME:
      legacyConfig(config);
  }

  // the root font size will be 16px by default, which matches the base config.
  // semantic.min.js appears to be setting this to 14px for the HPX kiosk.
  // allowing override by theme setting here
  document.documentElement.style.fontSize = config.root_font_size;
}
